module.exports = __webpack_public_path__ + "zmenseni-prsou_3_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_3_before.jpg
// module id = 1282
// module chunks = 0